
<template lang="pug">
QDatetimeMod.select-ref-date(
  v-bind="$attrs"
  :value="timestamp"
  format="YYYY年M月D日(ddd)"
  format-model="number"
  v-on="listeners"
)
</template>

<script>
import {isValid} from 'date-fns/esm'

import {dateToObject, dateToString} from 'helpers/date'

import QDatetimeMod from 'components/QDatetimeMod'

export default {
  components: {QDatetimeMod},

  props: {
    value: {required: true},
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: timestamp => {this.inputted(timestamp)},
        change: timestamp => {this.changed(timestamp)},
      }
    },

    timestamp() {
      const date = dateToObject(this.value)
      return isValid(date) ? date.valueOf() : null
    },
  },

  methods: {
    inputted(timestamp) {
      const date = new Date(timestamp)
      if(isValid(date)) {
        this.$emit('input', dateToString(date))
      }
    },

    changed(timestamp) {
      const date = new Date(timestamp)
      if(isValid(date)) {
        this.$emit('change', dateToString(date))
      }
    },
  },
}
</script>

<style lang="sass">
.select-ref-date
  width: 11rem
</style>
